import * as m from "mithril";
import {FormState} from "@arco-tech/audit_web_sdk/FormState";
import {PublishedForm, PublishedFormSection} from "@arco-tech/audit_web_sdk/PublishedForm";
import {block} from "@arco-tech/audit_web_sdk/BEM";

interface Attrs {
  publishedForm: PublishedForm;
  formState: FormState;
}

type Vnode = m.Vnode<Attrs>;

export const FormSectionNavigation: m.Component<Attrs> = {
  view: ({attrs: {publishedForm, formState}}: Vnode) => {
    const sections = publishedForm.form().sections();
    return m(".form-section-navigation", [
      sections.map((section) => {
        return m(block(
          "form-section-navigation__item",
          modifiers(formState, publishedForm, section),
        ), section.name());
      }),
    ]);
  },
};

function modifiers(
  formState: FormState,
  publishedForm: PublishedForm,
  section: PublishedFormSection,
): string[] {
  const mods = [];
  const currentSection = formState.findCurrentSection(publishedForm);
  if (section.index() < currentSection.index()) {
    mods.push("complete");
  }
  if (section.id() === currentSection.id()) { mods.push("active"); }
  return mods;
}
